import { default as MuiAccordionDetails, AccordionDetailsProps } from '@mui/material/AccordionDetails'
import * as React from 'react'

const AccordionDetails: React.FC<React.PropsWithChildren<AccordionDetailsProps>> = (props) => {
  return <MuiAccordionDetails {...props} />
}

export default AccordionDetails
